import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2e7d32',
      light: '#43a047',
      dark: '#1b5e20',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f9a825',
      light: '#ffd54f',
      dark: '#e65100',
      contrastText: '#1a1a1a',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a3a1e',
      secondary: '#4a6741',
    },
    success: { main: '#43a047' },
    grey: {
      50: '#f9fbe7',
      100: '#f1f8e9',
      200: '#e8f5e9',
    },
  },
  typography: {
    fontFamily: "'Outfit', sans-serif",
    h1: { fontFamily: "'Playfair Display', serif", fontWeight: 700, lineHeight: 1.12, letterSpacing: '-0.02em' },
    h2: { fontFamily: "'Playfair Display', serif", fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.01em' },
    h3: { fontFamily: "'Playfair Display', serif", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontFamily: "'Playfair Display', serif", fontWeight: 600, lineHeight: 1.35 },
    h5: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, lineHeight: 1.4, letterSpacing: '0.04em', textTransform: 'uppercase' },
    h6: { fontFamily: "'Outfit', sans-serif", fontWeight: 600 },
    body1: { fontFamily: "'Outfit', sans-serif", fontWeight: 400, lineHeight: 1.78 },
    body2: { fontFamily: "'Outfit', sans-serif", fontWeight: 400, lineHeight: 1.68 },
    button: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase' },
    overline: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, letterSpacing: '0.16em', fontSize: '0.7rem', textTransform: 'uppercase' },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '11px 26px',
          fontSize: '0.8rem',
          letterSpacing: '0.08em',
          transition: 'all 0.3s ease',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #2e7d32 0%, #43a047 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(46,125,50,0.30)',
          },
        },
        outlinedPrimary: {
          borderWidth: '2px',
          '&:hover': { borderWidth: '2px', backgroundColor: 'rgba(46,125,50,0.06)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 16px rgba(0,0,0,0.05)',
          transition: 'all 0.35s cubic-bezier(0.4,0,0.2,1)',
          '&:hover': { boxShadow: '0 12px 40px rgba(0,0,0,0.10)', transform: 'translateY(-4px)' },
        },
      },
    },
    MuiAppBar: { styleOverrides: { root: { boxShadow: 'none' } } },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontFamily: "'Outfit', sans-serif", fontWeight: 600, letterSpacing: '0.04em' },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: 'rgba(46,125,50,0.15)' } },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#43a047' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2e7d32' },
          },
          '& .MuiInputLabel-root.Mui-focused': { color: '#2e7d32' },
        },
      },
    },
  },
});

export default theme;
